import { connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { combineReducers } from "redux";
import agencyEditReducer from "./reducers/agencyEdit";
import authReducer from "./reducers/auth";
import billFinderDataReducer from "./reducers/billFinderFormData";
import billTypesReducer from "./reducers/billTypes";
import calendarReducer from "./reducers/calendar";
import clientBillingReducer from "./reducers/clientBilling";
import clientContactsReducer from "./reducers/clientContacts";
import clientDashboardReducer from "./reducers/clientDashboard";
import clientLocalitiesReducer from "./reducers/clientLocalities";
import clientsDataReducer from "./reducers/clientManagementFormData";
import clientUsersReducer from "./reducers/clientUsers";
import currentLegislationReducer from "./reducers/currentLegislationData";
import deletedRecordsReducer from "./reducers/deletedRecordsArchive";
import emailAlertsReducer from "./reducers/emailAlerts";
import favoritesReducer from "./reducers/favorites";
import favoritesCombReducer from "./reducers/favoritesComb";
import groupingsReducer from "./reducers/groupings";
import historyHelpTextReducer from "./reducers/historyActionHelpText";
import intranetDashboardReducer from "./reducers/intranetDashboard";
import keywordHighlighterReducer from "./reducers/keywordHighlighterFormData";
import aiToolReducer from "./reducers/aiToolFormData";
import legSessionsReducer from "./reducers/legSessionsFormData";
import legisDataReducer from "./reducers/legisFormData";
import legisNewRecordReviewReducer from "./reducers/legisNewRecordReviewFormData";
import legisTrackInternalReducer from "./reducers/legisTrackInternalFormData";
import localDataReducer from "./reducers/localFormData";
import localReviewReducer from "./reducers/localReviewData";
import localTrackInternalReducer from "./reducers/localTrackInternalFormData";
import regsTrackInternalReducer from "./reducers/regsTrackInternalFormData";
import meetingDatesReducer from "./reducers/meetingDates";
import modalReducer from "./reducers/modal";
import personalNotesReducer from "./reducers/personalNotes";
import rawBillDataReducer from "./reducers/rawBillDataEntry";
import regionsReducer from "./reducers/regions";
import registerReviewReducer from "./reducers/registerReviewData";
import regsDataReducer from "./reducers/regsFormData";
import regsNewRecordReviewReducer from "./reducers/regsNewRecordReviewFormData";
import regsInjectorReducer from "./reducers/regsInjectorFormData";
import regsUrlReducer from "./reducers/regsUrls";
import reportLineReducer from "./reducers/reportLine";
import shareReportReducer from "./reducers/shareReport";
import sponsorInfoReducer from "./reducers/sponsorInfo";
import statusReviewReducer from "./reducers/statusReviewFormData";
import subjectChangesReducer from "./reducers/subjectChanges";
import subjectsReducer from "./reducers/subjects";
import trackingStatsReducer from "./reducers/trackingStats";
import undoReducer from "./reducers/undo";
import urlsSectionReducer from "./reducers/urlsSection";
import legislatorDataReducer from "./reducers/legislatorFormData";

const history = createBrowserHistory();

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    modal: modalReducer,
    legisFormData: legisDataReducer,
    regsFormData: regsDataReducer,
    localFormData: localDataReducer,
    auth: authReducer,
    reportLine: reportLineReducer,
    subjects: subjectsReducer,
    favorites: favoritesReducer,
    personalNotes: personalNotesReducer,
    billFinderFormData: billFinderDataReducer,
    clientsFormData: clientsDataReducer,
    clientContacts: clientContactsReducer,
    clientUsers: clientUsersReducer,
    emailAlerts: emailAlertsReducer,
    shareReport: shareReportReducer,
    favoritesComb: favoritesCombReducer,
    calendarData: calendarReducer,
    clientBilling: clientBillingReducer,
    localReview: localReviewReducer,
    registerReview: registerReviewReducer,
    regsNewRecordReview: regsNewRecordReviewReducer,
    legisNewRecordReview: legisNewRecordReviewReducer,
    legisTrackInternal: legisTrackInternalReducer,
    localTrackInternal: localTrackInternalReducer,
    regsTrackInternal: regsTrackInternalReducer,
    regsInjector: regsInjectorReducer,
    keywordHighlighter: keywordHighlighterReducer,
    aiTool: aiToolReducer, 
    legSessions: legSessionsReducer, 
    statusReview: statusReviewReducer,
    currentLegislation: currentLegislationReducer,
    trackingStats: trackingStatsReducer,
    deletedRecordsArchive: deletedRecordsReducer,
    subjectChanges: subjectChangesReducer,
    sponsorInfo: sponsorInfoReducer,
    groupings: groupingsReducer,
    undo: undoReducer,
    regions: regionsReducer,
    urlsSection: urlsSectionReducer,
    regsUrls: regsUrlReducer,
    rawBillData: rawBillDataReducer,
    billTypes: billTypesReducer,
    clientLocalities: clientLocalitiesReducer,
    agencyEdit: agencyEditReducer,
    historyHelpText: historyHelpTextReducer,
    meetingDates: meetingDatesReducer,
    clientDashboard: clientDashboardReducer,
    intranetDashboard: intranetDashboardReducer,
    legislatorData: legislatorDataReducer,
    router: connectRouter(history),
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js